/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_TechnicolorInputs */



/**
* | output |
* | --- |
* | "Technicolor Format" |
*
* @param {Ccsl_Export_Template_TechnicolorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_technicolor = /** @type {((inputs?: Ccsl_Export_Template_TechnicolorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_TechnicolorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format Technicolor")
	if (locale === "de") return /** @type {LocalizedString} */ ("Technicolor-Format")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato Technicolor")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Формат Техниколор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato Technicolor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("彩色格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テクニカラーフォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्नीकलर प्रारूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato Technicolor")
	return /** @type {LocalizedString} */ ("Technicolor Format")
});